import { Capacitor } from '@capacitor/core'

export const API_URL = process.env.REACT_APP_API_URL
export const PUBLIC_API_URL =
  process.env.REACT_APP_PUBLIC_API_URL
export const MODE =
  process.env.REACT_APP_MODE ?? 'production'
export const FEEDBACK_FORM_URL =
  process.env.REACT_APP_FEEDBACK_FORM_URL

export const IS_WEB = Capacitor.getPlatform() === 'web'
